import {
  LOADING_PAGE,
  LOADED_PAGE,
} from '../../constants/actionTypes';

const INITIAL_STATE = {
  isLoading: true,
};

const applyIsLoading = (state, action) => ({
  isLoading: true,
});

const applyIsLoaded = (state, action) => ({
  isLoading: false,
});

const loadingPageReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOADING_PAGE:
      return applyIsLoading(state, action);
    case LOADED_PAGE:
      return applyIsLoaded(state, action);
    default:
      return state;
  }
};

export default loadingPageReducer;
